<template>
  <div
    class="toast"
    :class="{
      'toast--visible': toastStore.visible,
      'toast--info': toastStore.toastColor === 'info',
      'toast--success': toastStore.toastColor === 'success',
      'toast--danger': toastStore.toastColor === 'danger',
    }"
  >
    <div class="toast__icon">
      <component
        v-if="toastStore.toastColor"
        :is="
          toastStore.toastColor === 'info'
            ? PhInfo
            : toastStore.toastColor === 'danger'
              ? PhWarningOctagon
              : PhCheck
        "
      />
    </div>
    <span class="toast__label" v-html="toastStore.toastMessage"></span>
  </div>
</template>

<script setup lang="ts">
import { useToastStore } from '@/stores/toast.ts'
import { PhCheck, PhInfo, PhWarningOctagon } from '@phosphor-icons/vue'

const toastStore = useToastStore()
</script>
